<div class="py-4">
  <!-- Add Role button -->
  <div class="flex items-center gap-4 mb-4 flex-wrap">
    <button mat-raised-button color="primary" (click)="addRole()" [disabled]="!orgId()">
      <mat-icon>add</mat-icon>
      {{ 'Add Role' | translate }}
    </button>
  </div>

  <!-- Loading spinner -->
  @if (loading) {
  <div class="flex justify-center py-10">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  }

  <!-- No org selected -->
  @if (!orgId() && !loading) {
  <div class="text-center py-10 text-gray-400 text-sm">
    {{ 'Please select an organization' | translate }}
  </div>
  }

  <!-- No roles -->
  @if (orgId() && !loading && vendorRoles.length === 0) {
  <div class="text-center py-10 text-gray-400 text-sm">
    {{ 'No vendor roles found for this organization' | translate }}
  </div>
  }

  <!-- Roles table -->
  @if (orgId() && !loading && vendorRoles.length > 0) {
  <table mat-table [dataSource]="vendorRoles" class="w-full">
    <!-- Role Name -->
    <ng-container matColumnDef="roleName">
      <th mat-header-cell *matHeaderCellDef>{{ 'Role Name' | translate }}</th>
      <td mat-cell *matCellDef="let role">{{ role.role_name }}</td>
    </ng-container>

    <!-- Description -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>{{ 'Description' | translate }}</th>
      <td mat-cell *matCellDef="let role">{{ role.role_description || '—' }}</td>
    </ng-container>

    <!-- Active -->
    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef>{{ 'Active' | translate }}</th>
      <td mat-cell *matCellDef="let role">
        <span
          [class]="
            role.is_active
              ? 'inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-50 text-green-800'
              : 'inline-block px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-50 text-red-800'
          "
        >
          {{ role.is_active ? ('Yes' | translate) : ('No' | translate) }}
        </span>
      </td>
    </ng-container>

    <!-- Visible Statuses -->
    <ng-container matColumnDef="statuses">
      <th mat-header-cell *matHeaderCellDef>{{ 'Visible Statuses' | translate }}</th>
      <td mat-cell *matCellDef="let role">
        <app-status-tooltip [allStatuses]="allStatuses" [visibleStatusIds]="getVisibleStatusIds(role)" />
      </td>
    </ng-container>

    <!-- Actions -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>{{ 'Actions' | translate }}</th>
      <td mat-cell *matCellDef="let role">
        <button mat-icon-button matTooltip="{{ 'Edit' | translate }}" (click)="editRole(role)">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button matTooltip="{{ 'Delete' | translate }}" color="warn" (click)="deleteRole(role)">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  }
</div>
